import { scopeParamsFromScope } from './url';

/**
 * Links that carry one exact row from a GSC tool into the tool that answers the next question
 * about it. They are links rather than requests made from the calling report: the next tool reads
 * the address the same way it reads a shared link, so a carried row lands under the same scope
 * and with the same validation as one typed by hand.
 */

/** Query parameters with the empty ones dropped, so a link never carries `country=` or worse. */
function query(params) {
    const filled = Object.entries(params).filter(
        ([, value]) => value !== undefined && value !== null && value !== '',
    );
    return new URLSearchParams(filled).toString();
}

/**
 * URL Inspection for one exact URL. It fills that tool's fields and nothing more: an inspection
 * spends the property's quota, so it waits there for the user to press Inspect.
 */
export function urlInspectionLink(siteUrl, url) {
    return `/domains/tools/url-inspection/?${query({ site: siteUrl, url })}`;
}

/**
 * Pages, Queries & Changes on one view, under the calling report's scope and the session rules
 * given — `{ dimension, operator, expression }` each, in Search Console's own terms.
 *
 * The window is the caller's detail window, which is already held to the detail bound that report
 * runs under, so the link lands on the same days the row was read over rather than on a window the
 * other report would refuse. That report runs a scope found in its address on arrival.
 */
export function pagesQueriesLink(scope, period, { view, rules }) {
    const params = {
        ...scopeParamsFromScope({ ...scope, current: period }),
        view,
        mode: scope.mode,
        metric: scope.metric,
        rules: JSON.stringify(rules.map((rule) => ({ name: '', ...rule }))),
    };

    return `/domains/tools/pages-queries-changes/?${query(params)}`;
}
